import React, {useState, useEffect} from "react"
import {useTranslation} from "react-i18next";
import MenuItem from "@mui/material/MenuItem";

import MDInput from "materialDashboard/components/MDInput";
import {formatISODate, getSeasonFromDate} from "../../../utils/date";
import {subYears} from "date-fns";


export const SeasonSelect = ({dateGte, dateLte, setDateGte, setDateLte, ...props}) => {
    const {t} = useTranslation("inputs");
    const [value, setValue] = useState("");
    const today = new Date();

    // last ten years like 20xx/20yy
    const availableSeasons = Array.from({length: 10}, (_, i) => {
        return getSeasonFromDate(subYears(today, i));
    });
    availableSeasons.push({label: t("seasonSelect.all"), from:null, to:null})

    const selectedSeason = availableSeasons.find(season => {
        return formatISODate(dateGte) === formatISODate(season.from) && formatISODate(dateLte) === formatISODate(season.to);
    })

    useEffect(() => {
        if (selectedSeason) {
            setValue(selectedSeason.label);
        } else{
            setValue("");
        }
    }, [selectedSeason])

    const handleChange = (e) => {
        setValue(e.target.value)
        const season = availableSeasons.find( s => s.label === e.target.value);
        if (season) {
            setDateGte(season.from);
            setDateLte(season.to);
        }
    }
    return <MDInput label={t("seasonSelect.label")}
                    value={value}
                    onChange={handleChange}
                    variant="standard"
                    select
                    {...props}>
        {
            availableSeasons.map(season => (
                <MenuItem key={season.label} value={season.label}>{season.label}</MenuItem>
            ))
        }
    </MDInput>
}

export default SeasonSelect;